import { EntityFieldReport } from "../../@types/entity/field/report/field-report"
import { ConfigTable } from "../../@types/interfaces/table-interface"
import { ParseDateToBr } from "helper/format-date-helper"
import { ReactNode } from "react"
import { Col, Form, Pagination, Row, Table } from "react-bootstrap"

type PropsTable = {
    tableHeader: any[]
    tableBody: any[],
    entityFields: EntityFieldReport[]
    configTable: ConfigTable
    onClickCheckboxRow?: any
    onClickCheckboxColumn?: any
    onClickSaveRow?: any
    onBlurSaveRow?: any
    onClickOpenModal?: any

    onClickFirstPagination?: any
    onClickLastPagination?: any
    onClickNextPagination?: any
    onClickPrevPagination?: any
    paginationItemList?: any
    onClickItemPagination?: any
    pageDescriptionPagination?: string
}

const CreateModalReport: React.FC<PropsTable> = ({
    tableHeader,
    tableBody,
    entityFields,
    configTable,
    onClickCheckboxRow,
    onClickCheckboxColumn,
    onClickSaveRow,
    onBlurSaveRow,
    onClickOpenModal,
    onClickFirstPagination,
    onClickLastPagination,
    onClickNextPagination,
    onClickPrevPagination,
    pageDescriptionPagination,
    paginationItemList,
    onClickItemPagination, }: PropsTable) => {
    return (
        <Table responsive style={{ cursor: "pointer" }}>
            <thead>
                <tr>
                    {configTable.checkboxes ?
                        <th style={{ whiteSpace: "nowrap" }} className="m-0 p-0">
                            <Form.Check type="checkbox" className="ms-1 mb-1" onClick={onClickCheckboxColumn} />
                        </th>
                        :
                        <></>
                    }
                    {tableHeader.map((value, index) => {
                        return <th key={index} style={{ whiteSpace: "nowrap", textAlign: value.align }}>{value.labelTable}</th>
                    })}
                </tr>
            </thead>
            <tbody>
                {tableBody.map((value, index) => {

                    return <tr
                        key={index}
                        onClick={() => {
                            if (configTable.openModal) {
                                onClickOpenModal(value)
                            }
                        }}>

                        {configTable.checkboxes ?
                            <td key={index} className="m-0 p-0">
                                <Form.Check type="checkbox" className="ms-1 me-2" onChange={() => { onClickCheckboxRow(value) }} checked={value["checked"]} />
                            </td>
                            :
                            <></>
                        }

                        {tableHeader.map((v, i) => {

                            if (entityFields[i] !== undefined) {

                                let typeField = entityFields[i].typeField
                                let align = entityFields[i].align
                                let fieldValue = value[v.name]

                                if (fieldValue !== null || fieldValue !== undefined) {

                                    let className = `d-flex align-items-center justify-content-${align} m-0 p-0 mx-2`
                                    if (align === "left")
                                        className = `d-flex align-items-center justify-content-start m-0 p-0 mx-2`
                                    if (align === "right")
                                        className = `d-flex align-items-center justify-content-end m-0 p-0 mx-2`

                                    if (typeField === "date") {
                                        return (
                                            <td key={i} className="m-0 p-0">
                                                <div className={className} style={{ whiteSpace: "nowrap", fontWeight: 250 }}>{ParseDateToBr(fieldValue)}</div>
                                            </td>
                                        )
                                    }
                                    else if (typeField === "text") {
                                        return (
                                            <td key={i} className="m-0 p-0">
                                                <div className={className} style={{ whiteSpace: "nowrap", fontWeight: 250 }}>{fieldValue}</div>
                                            </td>
                                        )
                                    }
                                    else if (typeField === "monetary") {
                                        if (fieldValue !== null) {
                                            return (
                                                <td key={i} className="m-0 p-0">
                                                    <div className={className} style={{ whiteSpace: "nowrap", fontWeight: 250 }}>{fieldValue.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</div>
                                                </td>
                                            )
                                        }
                                    }
                                    else if (typeField === "radio") {
                                        return (
                                            <td key={i} className="m-0 p-0">
                                                <div className={className} style={{ whiteSpace: "nowrap", fontWeight: 250 }}>{fieldValue}</div>
                                            </td>
                                        )
                                    }
                                    else if (typeField === "number") {
                                        return (
                                            <td key={i} className="m-0 p-0">
                                                <div className={className} style={{ whiteSpace: "nowrap", fontWeight: 250 }}>{fieldValue}</div>
                                            </td>
                                        )
                                    }
                                    else if (typeField === "html") {
                                        return (
                                            <td key={i} className="m-0 p-0" >
                                                <div className="d-flex align-items-center justify-content-center m-0 p-0" style={{ whiteSpace: "nowrap", fontWeight: 250 }}>{fieldValue}</div>
                                            </td>
                                        )
                                    }
                                    else if (typeField === "input") {
                                        let id = value["id"]
                                        let quantidadeMaxima = value["quantidade"] || 0
                                        let valorInicial = Number(fieldValue) || 0  // Valor inicial do campo
                                        // Garante que o campo quantidadeAuditor sempre esteja habilitado
                                        const isDisabled = entityFields[i]?.name === "quantidadeAuditor" ? false : (entityFields[i]?.disabled || false)
                                        // Verifica se é o campo quantidadeAuditor para aplicar validação de números inteiros
                                        const isQuantidadeAuditor = entityFields[i]?.name === "quantidadeAuditor"

                                        return (
                                            <td key={i} className="m-0 p-0">
                                                <div className="d-flex align-items-center justify-content-center m-0 p-0">
                                                    <div>
                                                        <Form.Control
                                                            className="m-0 p-0"
                                                            type="number"
                                                            defaultValue={fieldValue}
                                                            size="sm"
                                                            disabled={isDisabled}
                                                            min={0}
                                                            max={quantidadeMaxima}
                                                            step={isQuantidadeAuditor ? "1" : undefined}
                                                            data-valor-inicial={valorInicial}
                                                            onFocus={(e) => {
                                                                // Captura o valor inicial quando o campo recebe foco
                                                                // Se o campo já foi editado antes, usa o valor atual como inicial
                                                                const valorAtual = Number(e.target.value) || 0;
                                                                e.target.setAttribute('data-valor-inicial', valorAtual.toString());
                                                            }}
                                                            onKeyDown={(e) => {
                                                                // Bloqueia vírgula, ponto, 'e', 'E', '+' e '-' para campos quantidadeAuditor
                                                                if (isQuantidadeAuditor) {
                                                                    if (e.key === ',' || e.key === '.' || e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                                                                        e.preventDefault();
                                                                    }
                                                                }
                                                            }}
                                                            onChange={(e) => {
                                                                // Remove vírgulas e pontos para campos quantidadeAuditor
                                                                if (isQuantidadeAuditor) {
                                                                    let valor = e.target.value;
                                                                    // Remove vírgulas e pontos
                                                                    valor = valor.replace(/[,.]/g, '');
                                                                    e.target.value = valor;
                                                                }
                                                                
                                                                const inputValue = Number(e.target.value);
                                                                if (inputValue < 0) {
                                                                    e.target.value = '0';
                                                                } else if (inputValue > quantidadeMaxima) {
                                                                    e.target.value = quantidadeMaxima.toString();
                                                                }
                                                            }}
                                                            onBlur={(e) => {
                                                                // Verifica se o campo está vazio, null ou undefined
                                                                const valorCampo = e.target.value;
                                                                let quantidadeFinal = 0;

                                                                if (valorCampo === '' || valorCampo === null || valorCampo === undefined) {
                                                                    // Se estiver vazio, define como zero
                                                                    e.target.value = '0';
                                                                    quantidadeFinal = 0;
                                                                } else {
                                                                    const inputValue = Number(valorCampo);
                                                                    quantidadeFinal = isNaN(inputValue) ? 0 : inputValue;

                                                                    // Ajusta o valor se estiver fora dos limites
                                                                    if (quantidadeFinal < 0) {
                                                                        e.target.value = '0';
                                                                        quantidadeFinal = 0;
                                                                    } else if (quantidadeFinal > quantidadeMaxima) {
                                                                        e.target.value = quantidadeMaxima.toString();
                                                                        quantidadeFinal = quantidadeMaxima;
                                                                    } else {
                                                                        // Garante que o valor seja um número inteiro
                                                                        quantidadeFinal = Math.floor(quantidadeFinal);
                                                                        e.target.value = quantidadeFinal.toString();
                                                                    }
                                                                }

                                                                // Obtém o valor inicial armazenado no atributo data
                                                                const valorInicialStr = e.target.getAttribute('data-valor-inicial') || valorInicial.toString();
                                                                const valorInicialAtual = Number(valorInicialStr) || 0;

                                                                // Compara o valor final com o valor inicial
                                                                // Só chama o saveRow se o valor realmente mudou
                                                                if (quantidadeFinal !== valorInicialAtual && onBlurSaveRow) {
                                                                    onBlurSaveRow({
                                                                        id: id,
                                                                        quantidade: quantidadeFinal,
                                                                        quantidadeAntiga: valorInicialAtual
                                                                    });
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    {/* <div className="m-1 ms-2">
                                                        <BsCheckLg size={10} color={"#28A745"} onClick={() => onClickSaveRow({id: id, quantidade: quantidade})} />
                                                    </div> */}
                                                </div>
                                            </td>
                                        )
                                    }
                                    else
                                        return (
                                            <td key={i} className="m-0 p-0">
                                                <div className="d-flex align-items-center justify-content-center m-0 p-0" style={{ whiteSpace: "nowrap", fontWeight: 250 }}>
                                                    {fieldValue}
                                                </div>
                                            </td>
                                        )
                                }
                            }
                        })}
                    </tr>
                })}

                {configTable.pagination
                    ?
                    <PaginationTable
                        children={<></>}
                        configTable={configTable}
                        onClickFirstPagination={onClickFirstPagination}
                        onClickLastPagination={onClickLastPagination}
                        onClickNextPagination={onClickNextPagination}
                        onClickPrevPagination={onClickPrevPagination}
                        pageDescriptionPagination={pageDescriptionPagination!}
                        itemList={paginationItemList}
                        onClickItem={onClickItemPagination}
                    />
                    :
                    <div></div>
                }
            </tbody>
        </Table>
    )
}

export default CreateModalReport

type PropsPagination = {
    children: ReactNode
    configTable: ConfigTable
    onClickFirstPagination: any,
    onClickLastPagination: any,
    onClickNextPagination: any,
    onClickPrevPagination: any
    pageDescriptionPagination: string,
    itemList: any
    onClickItem: any
}

const PaginationTable: React.FC<PropsPagination> = ({
    children,
    configTable,
    onClickFirstPagination,
    onClickLastPagination,
    onClickNextPagination,
    onClickPrevPagination,
    pageDescriptionPagination,
    itemList,
    onClickItem
}: PropsPagination) => {

    async function handlePaginationFirst() { await onClickFirstPagination() }
    async function handlePaginationPrev() { await onClickPrevPagination() }
    async function handlePaginationNext() { await onClickNextPagination() }
    async function handlePaginationLast() { await onClickLastPagination() }

    return (
        <div className="mt-4">
            <Row className="d-flex align-items-center justify-content-between">

                <Col className="d-flex justify-content-start">
                </Col>
                <Col >
                    <div className="d-flex justify-content-center">
                        <Pagination size="sm">
                            <Pagination.First onClick={onClickFirstPagination}>Primeira</Pagination.First>
                            <Pagination.Prev onClick={onClickPrevPagination} >Anterior</Pagination.Prev>
                            {itemList?.map((value: any, key: any) => {
                                return (<Pagination.Item key={key} active={value.active} onClick={() => onClickItem(value)}>{value.item + 1}</Pagination.Item>)
                            })}
                            <Pagination.Next onClick={onClickNextPagination} >Próxima</Pagination.Next>
                            <Pagination.Last onClick={onClickLastPagination} >Última</Pagination.Last>
                        </Pagination>
                    </div>
                </Col>
                <Col className="d-flex justify-content-end">
                    {configTable.buttonFooter ? children : <></>}
                </Col>
            </Row>
        </div>
    )
}
// ****************************************